'use memo';

import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'hooks/useAppSelector';
import { LoadingState } from 'utils/loadingState';
import { shouldHideReportingDashboard } from './reportingDashboardAccess';
import ReportingDashboard from './reportingDashboard';

const HomeDashboardPath = '/';

const ReportingDashboardRoute = () => {
  const accountType = useAppSelector(state => state.agentInfo.accountType);
  const { loadingState, info } = useAppSelector(
    state => state.agencies.agencyInfo
  );

  if (loadingState !== LoadingState.Loaded) return null;

  const agencyAccountType = info.accountType ?? accountType;

  if (shouldHideReportingDashboard(agencyAccountType)) {
    return <Navigate to={HomeDashboardPath} replace />;
  }

  return <ReportingDashboard />;
};

export default ReportingDashboardRoute;
